var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout-default"}},[_c('header',[_c('TopBar')],1),_c('content',[_vm._t("default")],2),_c('footer',[_c('BottomBar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }